export const getSelectedPaymentOptionIndex = state => state.payment.paymentOptionIndex;
